import axios from 'axios'
// import crypto from 'crypto'
axios.defaults.baseURL = 'http://111.229.214.104:8000'


const state = {
}

const mutations = {
}
const actions = {
// 验证手机号是否可以进行修改密码
getMobile({ commit },data) {
  commit('GET_MOBILE')
  // console.log(data)
return axios.get('mobile/' + data +'/count/').then((res) => {
      // commit('GET_MOBILE',res.data.count)
      return res
})
},
// 手机号以及验证码提交
getPass({ commit },data) {
  commit('GET_PASS')
// console.log(data)
return axios.get('/sms_code/?mobile='+ data.mobile+ '&num=' + data.num + '&code=' + data.code).then((res) => {
  return res
})
},
getpasssword({commit},data) {
  commit('GET_PASS')
  return axios.post('/getpassword/',data).then((res) => {
    return res
  })
},
// 更改密码
putPassword ({ commit },data) {
  commit('PUT_PASS')
  return axios.post ('/putpassword/',data).then((res) => {
    return res
  })
}
}

const getters = {

}

const ForgetModule = {
  state,
  mutations,
  actions,
  getters
}

export default ForgetModule
